module.exports = __webpack_public_path__ + "static/media/mt.105e04ca.jpg";